import { apiClient } from '../client'
import type { ApiPaginatedResponse, ApiSuccessResponse } from '../../types/api'
import type { Reviewer, ReviewerFormPayload, ReviewerListParams } from '../../types/reviewer'

export const reviewerService = {
  async list(params?: ReviewerListParams) {
    const { data } = await apiClient.get<ApiPaginatedResponse<Reviewer> | ApiSuccessResponse<Reviewer[]>>(
      '/reviewers',
      { params },
    )
    return data
  },

  async show(id: string) {
    const { data } = await apiClient.get<ApiSuccessResponse<Reviewer>>(`/reviewers/${id}`)
    return data
  },

  async create(payload: ReviewerFormPayload) {
    const { data } = await apiClient.post<ApiSuccessResponse<Reviewer>>('/reviewers', payload)
    return data
  },

  async update(id: string, payload: ReviewerFormPayload) {
    const { data } = await apiClient.put<ApiSuccessResponse<Reviewer>>(`/reviewers/${id}`, payload)
    return data
  },

  async remove(id: string) {
    const { data } = await apiClient.delete<ApiSuccessResponse<null>>(`/reviewers/${id}`)
    return data
  },

  async restore(id: string) {
    const { data } = await apiClient.post<ApiSuccessResponse<Reviewer>>(`/reviewers/${id}/restore`)
    return data
  },
}
